import type { AudioPlayerCardActionLink } from "../../types/audio-player-card";

import { TrackableLink } from "../TrackableLink";
import { AudioPlayerCardSpotifyIcon } from "./AudioPlayerCardSpotifyIcon";

type AudioPlayerCardSpotifyLinkProps = {
  link: AudioPlayerCardActionLink;
};

function AudioPlayerCardSpotifyLink({ link }: AudioPlayerCardSpotifyLinkProps) {
  return (
    <TrackableLink
      aria-label={`${link.label} (opens in a new tab)`}
      className="size-6 shrink-0 text-new-beginnings-base transition-opacity hover:opacity-70 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      href={link.url}
      onLinkClick={() => link.onSelect?.()}
      rel="noreferrer"
      size="inline"
      target="_blank"
      variant="plain"
    >
      <AudioPlayerCardSpotifyIcon />
      <span className="sr-only">(opens in a new tab)</span>
    </TrackableLink>
  );
}

export { AudioPlayerCardSpotifyLink };
